export const CLEAR_STORES = 'CLEAR_STORES';
export const REFRESH_CONNECTIONS_STATS = 'REFRESH_CONNECTIONS_STATS';
export const REFRESH_CONNECTIONS_STATS_STARTING = 'REFRESH_CONNECTIONS_STATS_STARTING';
export const FILTER_CONNECTIONS = 'FILTER_CONNECTIONS';
export const ACCEPT_CONNECTION_STARTING = 'ACCEPT_CONNECTION_STARTING';
export const IGNORE_CONNECTION_STARTING = 'IGNORE_CONNECTION_STARTING';
export const REMOVE_CONNECTION_STARTING = 'REMOVE_CONNECTION_STARTING';
export const UNDO_CONNECTION_CHANGE = 'UNDO_CONNECTION_CHANGE';
export const LOG_OUT = 'LOG_OUT';



// WEBPACK FOOTER //
// ./src/app/stores/connections-stats/connections-stats-constants.js